import { Components, Theme } from "@mui/material";

export const MuiFormControlLabel: Components<Theme>["MuiFormControlLabel"] = {
  styleOverrides: {
    root: {
      marginLeft: 0,
    },
  },
};
